import { Injectable } from '@angular/core';
import { IArticle } from '@alberta/konexi-shared';
import { UntypedFormGroup } from '@angular/forms';
import { caluclateDurationToDays } from 'src/app/business/order/duration2daysCalcuator';

@Injectable()
export class AddArticleService {
  public calcIfMaxAmountIsExceeded(
    form: UntypedFormGroup,
    article: IArticle,
    maxAmount: number
  ): { [key: string]: any } | null {
    const packagingUnit = article.packagingUnits.find(unit => unit._id === form.controls['packagingId'].value);
    if (!packagingUnit) {
      return null;
    }
    const amountInPieces = form.controls['quantity'].value * packagingUnit.quantity;
    const days = caluclateDurationToDays({
      amount: form.controls['interval'].value,
      timePeriod: form.controls['period'].value,
    });
    const amountInPiecesIn30Days = (amountInPieces / days) * 30;
    const forbidden = maxAmount !== -1 && amountInPiecesIn30Days > maxAmount;
    return forbidden ? { maxAmountExceeded: true } : null;
  }
}
